import Repository from './Repository';

const resource = '/security';

export default class SecurityRepository {
  static login(login, password) {
    return Repository.post(`${resource}/login`, { login, password });
  }
}
